(function () {
  let refreshTimer;

  async function refreshBundleBar() {
    const bar = document.querySelector(".rmds-bundlebar");
    if (!bar) return;

    try {
      const res = await fetch("/?section_id=quick-cart", { credentials: "same-origin" });
      const html = await res.text();

      const temp = document.createElement("div");
      temp.innerHTML = html;

      const newBar = temp.querySelector(".rmds-bundlebar");
      if (newBar) bar.replaceWith(newBar);
    } catch (e) {
      // fail silently
    }
  }

  function queueRefresh(delay = 300) {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshBundleBar, delay);
  }

  // 1) Catch add-to-cart forms (common)
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!form || !form.action) return;
    if (form.action.includes("/cart/add")) queueRefresh(500);
  }, true);

  // 2) Catch clicks on add buttons (backup)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest('button[name="add"], [data-add-to-cart], .product-form__submit');
    if (btn) queueRefresh(700);
  });

  // 3) Catch quantity changes inside drawer
  document.addEventListener("change", (e) => {
    const qty = e.target.closest('input[name="updates[]"], input[data-quantity-input], select[name="updates[]"]');
    if (qty) queueRefresh(500);
  });

  // 4) Most reliable: hook into fetch/XHR cart calls
  const origFetch = window.fetch;
  window.fetch = function () {
    const p = origFetch.apply(this, arguments);
    try {
      const url = (arguments[0] && arguments[0].url) ? arguments[0].url : arguments[0];
      if (typeof url === "string" && url.includes("/cart/")) {
        p.then(() => queueRefresh(200));
      }
    } catch (_) {}
    return p;
  };

  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._rmds_url = url;
    return origOpen.apply(this, arguments);
  };

  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener("load", () => {
      try {
        if (this._rmds_url && this._rmds_url.includes("/cart/")) queueRefresh(200);
      } catch (_) {}
    });
    return origSend.apply(this, arguments);
  };
})();